import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router";
import React, { useEffect, useState } from "react";
import styles from "./QuotationItem.module.scss";
import { openMainModal, closeMainModal, deleteQuotation, updateQuotation } from "../../store/actions";
import { fireAnalytics } from "../../utils/firebase";
import { ReactComponent as LeftErrorIcon } from "../../assets/svg/errorRed.svg";
import { ReactComponent as ArrowDown } from "../../assets/svg/arrowDownIcon.svg";
import { ReactComponent as ArrowUp } from "../../assets/svg/arrowUpIcon.svg";
import usePremiumCheck from "../../hooks/usePremiumCheck";
import ProjectProfileData from "../UserData/UserData";
import SubQuotationRubro from "./subCotizacion/SubQuotationRubro";
import BuenosAiresIcono from "../../assets/images/BuenosAiresIcono.jpg";
import CabaIcono from "../../assets/images/cabaIcon.jpg";
import CatamarcaIcono from "../../assets/images/catamarcaIcono.jpg";
import ChacoIcono from "../../assets/images/chacoIcono.jpg";
import ChubutIcono from "../../assets/images/chubutIcono.jpg";
import CordobaIcono from "../../assets/images/cordobaIcono.jpg";
import CorrientesIcono from "../../assets/images/corrientesIcono.jpg";
import EntreRiosIcono from "../../assets/images/entreRiosIcono.jpg";
import FormosaIcono from "../../assets/images/formosaIcono.jpg";
import JujuyIcono from "../../assets/images/jujuyIcono.jpg";
import LaPampaIcono from "../../assets/images/laPampaIcono.jpg";
import LaRiojaIcono from "../../assets/images/laRiojaIcono.jpg";
import MendozaIcono from "../../assets/images/mendozaIcono.jpg";
import MisionesIcono from "../../assets/images/misionesIcono.jpg";
import NeuquenIcono from "../../assets/images/neuquenIcono.jpg";
import RioNegroIcono from "../../assets/images/rioNegroIcono.jpg";
import SaltaIcono from "../../assets/images/saltaIcono.jpg";
import SanJuanIcono from "../../assets/images/sanJuanIcono.jpg";
import SanLuisIcono from "../../assets/images/sanLuisIcono.jpg";
import SantaCruzIcono from "../../assets/images/santaCruzIcono.jpg";
import SantaFeIcono from "../../assets/images/santaFeIcono.jpg";
import SantiagoDelEsteroIcono from "../../assets/images/santiagoDelEsteroIcono.jpg";
import TierraDelFuegoIcono from "../../assets/images/tierraDelFuegoIcono.jpg";
import TucumanIcono from "../../assets/images/tucumanIcono.jpg";
import ArgentinaIcono from "../../assets/images/argentinaIcon.jpg";



const QuotationItem = ({
  openMainModal,
  closeMainModal,
  deleteQuotation,
  userData,
  updateQuotation,
  ...props }) => {
  const { item } = props;
  const {
    id,
    link,
    user,
  } = item;

  const [moreInfo, setMoreInfo] = useState(true);
  const [allowEdit, setAllowEdit] = useState(false);
  const [preparePostulation, setPreparePostulation] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [description, setDescription] = useState(item.description);
  const [startDate, setStartDate] = useState(item.startDate);
  const [endDate, setEndDate] = useState(item.endDate);
  const [name, setName] = useState(item.name);
  const [zone, setZone] = useState(item.zone);
  const [saveChanges, setSaveChanges] = useState(false);
  const history = useHistory();

  const userProject = props.profileVisualizer;



  //Array de iconos
  const iconJPG = [
    { id: 1, name: "Ciudad Autónoma de Buenos Aires", icon: CabaIcono },
    { id: 2, name: "Buenos Aires", icon: BuenosAiresIcono },
    { id: 3, name: "Catamarca", icon: CatamarcaIcono },
    { id: 4, name: "Chaco", icon: ChacoIcono },
    { id: 5, name: "Chubut", icon: ChubutIcono },
    { id: 6, name: "Córdoba", icon: CordobaIcono },
    { id: 7, name: "Corrientes", icon: CorrientesIcono },
    { id: 8, name: "Entre Ríos", icon: EntreRiosIcono },
    { id: 9, name: "Formosa", icon: FormosaIcono },
    { id: 10, name: "Jujuy", icon: JujuyIcono },
    { id: 11, name: "La Pampa", icon: LaPampaIcono },
    { id: 12, name: "La Rioja", icon: LaRiojaIcono },
    { id: 13, name: "Mendoza", icon: MendozaIcono },
    { id: 14, name: "Misiones", icon: MisionesIcono },
    { id: 15, name: "Neuquén", icon: NeuquenIcono },
    { id: 16, name: "Río Negro", icon: RioNegroIcono },
    { id: 17, name: "Salta", icon: SaltaIcono },
    { id: 18, name: "San Juan", icon: SanJuanIcono },
    { id: 19, name: "San Luis", icon: SanLuisIcono },
    { id: 20, name: "Santa Cruz", icon: SantaCruzIcono },
    { id: 21, name: "Santa Fe", icon: SantaFeIcono },
    { id: 22, name: "Santiago del Estero", icon: SantiagoDelEsteroIcono },
    { id: 23, name: "Tierra del Fuego,Antártida e Isla del Atlántico Sur", icon: TierraDelFuegoIcono },
    { id: 24, name: "Tucumán", icon: TucumanIcono },
    { id: 25, name: "Argentina", icon: ArgentinaIcono }
  ]

  //Definimos si son propias o ajenas las cotizaciones
  const isMyQuotations = history.location.pathname.includes(userData.id);

  const usuario = `${user?.name} ${user?.last_name}`;

  const premiumCheck = usePremiumCheck();

  //Formateamos las fechas 
  const formattedStartDate = item.startDate
    ? (() => {
      const dateObj = new Date(item.startDate);
      dateObj.setUTCHours(dateObj.getUTCHours());
      const day = dateObj.getUTCDate();
      const month = dateObj.getUTCMonth() + 1;
      const year = dateObj.getUTCFullYear();
      return `${day}/${month}/${year}`;
    })()
    : null;

  const formattedStartDateForInput = startDate
    ? (() => {
      const dateObj = new Date(startDate);
      dateObj.setUTCHours(dateObj.getUTCHours());
      const day = dateObj.getUTCDate();
      const month = dateObj.getUTCMonth() + 1;
      const year = dateObj.getUTCFullYear();

      const formattedYear = year;
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    })()
    : null;

  const formattedEndDate = item.endDate
    ? (() => {
      const dateObj = new Date(item.endDate);
      dateObj.setUTCHours(dateObj.getUTCHours());
      const day = dateObj.getUTCDate();
      const month = dateObj.getUTCMonth() + 1;
      const year = dateObj.getUTCFullYear();
      return `${day}/${month}/${year}`;
    })()
    : null;

  const formattedEndDateForInput = endDate
    ? (() => {
      const dateObj = new Date(endDate);
      dateObj.setUTCHours(dateObj.getUTCHours());
      const day = dateObj.getUTCDate();
      const month = dateObj.getUTCMonth() + 1;
      const year = dateObj.getUTCFullYear();

      const formattedYear = year;
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    })()
    : null;

  //Maneja el borrado de las cotizacion
  const handleDeleteQuotation = () => {
    setAllowEdit(!allowEdit);
    setPreparePostulation(!preparePostulation);
    setDropdownOpen(!dropdownOpen);
    setSaveChanges(false);
    fireAnalytics("delete_quotation", { category: "publishing" });
    openMainModal({
      title: "¿Estas seguro que deseas eliminar la cotización?",
      body: "Si eliminas la cotización no podrás recuperarla.",
      isSuccess: false,
      confirmHandler: () => {
        deleteQuotation(id);
        closeMainModal();
      },
    });
  }

  //Maneja el reseteo de los estados
  const handleReset = () => {
    setDescription(item.description);
    setStartDate(item.startDate);
    setEndDate(item.endDate);
    setName(item.name);
    setZone(item.zone);
    setAllowEdit(!allowEdit);
    setPreparePostulation(!preparePostulation);
    setDropdownOpen(!dropdownOpen);
    setSaveChanges(false);
  }

  //Maneja el estado del boton de guardar cambios
  useEffect(() => {
    if (item.description !== description ||
      item.startDate !== startDate ||
      item.endDate !== endDate ||
      item.name !== name ||
      item.zone !== zone) {
      setSaveChanges(true)
    } else {
      setSaveChanges(false)
    }
  }, [description, startDate, endDate, name, zone])


  //Maneja la edicion de la cotización
  const handleEditQuotation = () => {
    setAllowEdit(!allowEdit);
    setPreparePostulation(!preparePostulation);
    setDropdownOpen(!dropdownOpen);
    setSaveChanges(false);
    const editedDescription = description;
    const editedStartDate = startDate;
    const editedEndDate = endDate;
    const editedName = name;
    const editedZone = zone;

    const editedQuotation = {
      description: editedDescription,
      startDate: editedStartDate,
      endDate: editedEndDate,
      name: editedName,
      zone: editedZone,
    };
    fireAnalytics("edit_quotation", { category: "publishing" });
    updateQuotation(editedQuotation, id);
  }

  //Maneja cantidad de caracteres de la descripcion
  const descriptionLength = description?.length;
  const descriptionLengthLimit = 250;
  const descriptionLengthLeft = descriptionLengthLimit - descriptionLength;

  return (
    <div className={styles.fullCardContainer}>
      <ul className={styles.cardContainerList}>
        <li className={styles.cardContainerList_item}>
          <div className={styles.cardContainerList_iconContainer}>
            <p>
              {item.jurisdiccion === null || !item.jurisdiccion ? "No especificado" : (
                item.jurisdiccion?.name.charAt(0).toUpperCase() + item.jurisdiccion?.name.slice(1))}
            </p>

            {iconJPG.map((icon) => {
              return (
                <div key={icon.id}>
                  {icon.name === item.jurisdiccion?.name ? (
                    <img src={icon.icon} alt="icono" className={styles.cardContainerList_iconContainer_img} />
                  ) : null}
                </div>
              );
            })
            }
            {(item.jurisdiccion === null || item?.jurisdiccion === undefined) && (
              <img src={ArgentinaIcono} alt="icono" className={styles.cardContainerList_iconContainer_img} />
            )}
          </div>
        </li>
        <li className={styles.cardContainerList_item}>
          {allowEdit ? (
            <input
              type="text"
              className={styles.cardContainerList_item_nameEdit}
              value={name?.charAt(0).toUpperCase() + name?.slice(1)}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          ) : (
            <p className={styles.name_campo}>
              {item?.name?.charAt(0).toUpperCase() + item?.name?.slice(1)}
            </p>
          )}
        </li>
        <li className={styles.cardContainerList_item}>
          {Array.isArray(item?.subquotation) && item?.subquotation?.length > 0 ? (
            <div className={styles.rubros_subQuotation}>
              {item?.subquotation?.map((subQuotation, index) => {
                return (
                  <div className={styles.rubros_subQuotation_container} key={index}>
                    <p className={styles.rubros_subQuotation_title}>{subQuotation?.name}</p>
                  </div>
                )
              })}
            </div>
          ) : null}
        </li>
        <li className={styles.cardContainerList_item}>
          {allowEdit ? (
            <>
              <input
                type="date"
                className={styles.cardContainerList_item_dateEdit}
                value={formattedStartDateForInput}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
            </>
          ) : (
            <p className={styles.container_tableDate_startDate_date}>
              {formattedStartDate}
            </p>
          )}
        </li>
        <li className={styles.cardContainerList_item}>
          {allowEdit ? (
            <>
              <input
                type="date"
                className={styles.cardContainerList_item_dateEdit}
                value={formattedEndDateForInput}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              />
            </>
          ) : (
            <p className={styles.container_tableDate_endDate_date}>
              {formattedEndDate}
            </p>
          )}
        </li>
        <li className={styles.cardContainerList_item}>
          {allowEdit ? (
            <>
              <input
                type="text"
                className={styles.cardContainerList_item_lugarEdit}
                value={zone}
                onChange={(e) => {
                  setZone(e.target.value);
                }}
              />
            </>
          ) : (
            <p className={styles.container_input_lugar}>
              {item?.zone ? item.zone : "No especificado"}
            </p>
          )}
        </li>
        <li className={styles.cardContainerList_item}>
          <p className={styles.container_input_lugar}>
            {item?.currency ? item.currency : "$"}
          </p>
        </li>
        <li className={styles.cardContainerList_item}>
          {!isMyQuotations ? (
            <span className={styles.buttonText} onClick={premiumCheck(() => { setPreparePostulation(!preparePostulation); setDropdownOpen(!dropdownOpen) })}>
              {preparePostulation ? (
                <>
                  <div className={styles.fullQuotation_close} >
                    Ver menos
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.fullQuotation} >
                    Ver más
                  </div>
                </>
              )}
            </span>
          ) : (
            <div className={`${styles.editButton} ${allowEdit ? styles.editButton_containerIsEditing : ''}`}>
              <p className={styles.editButton_containerText} onClick={handleReset}>
                {allowEdit ? 'Cancelar' : 'Editar'}
              </p>
              {saveChanges ? (
                <button className={styles.editButton_saveChanges} onClick={handleEditQuotation}>
                  Guardar
                </button>
              ) : null}
              {allowEdit ? (
                <button className={styles.editButton_cancelEdit} onClick={handleDeleteQuotation}>
                  Eliminar
                </button>
              ) : null}
            </div>
          )}
        </li>
      </ul>
      {usuario && preparePostulation ? (
        <div className={styles.moreInfo}>
          <div className={styles.moreInfo_body}>
            <div className={styles.moreInfo_body_userContainer}>
              <h4 className={styles.moreInfo_body_title}>
                Usuario:
              </h4>
              <ProjectProfileData
                onClick={() => setMoreInfo(false)}
                userProject={userProject}
                usuarioImage={user?.image_profile}
                usuario={usuario}
                userId={user?.id}
                item={item}
              />
            </div>
            {allowEdit ? (
              <div className={styles.descriptionContainer}>
                <h4 className={styles.descriptionContainer_title}>Descripción general:</h4>
                <textarea
                  className={styles.descriptionContainer_edit}
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  maxLength={250}
                />
                <p className={styles.descriptionContainer_length}>{descriptionLengthLeft} /250</p>
              </div>
            ) : (
              <div className={styles.descriptionContainer}>
                <h4 className={styles.descriptionContainer_title}>Descripción general:</h4>
                <p className={styles.descriptionContainer_txt}>{description}</p>
              </div>
            )}
          </div>
          <div className={styles.details}>
            <h4 className={styles.details_title}>Detalles:</h4>
          </div>
          <div className={styles.rubros_container}>
            <SubQuotationRubro
              dashboardView={true}
              itemButtonText="Ver proyecto completo"
              item={item}
              key={item.id}
              type="subquotation"
              opened={!preparePostulation ? false : true}
              allowOpen={preparePostulation}
              userId={item?.user?.id}
              dropdownOpen={dropdownOpen}
              setDropdownOpen={setDropdownOpen}
              setPreparePostulation={setPreparePostulation}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    meSession: state.general.meSession,
    profileMenu: state.profile.menuShow,
    userData: state.general.userData,
  };
};

export default withRouter(connect(mapStateToProps, {
  openMainModal,
  closeMainModal,
  updateQuotation,
  deleteQuotation,
})(QuotationItem));